import { render, staticRenderFns } from "./emailSendRecord.vue?vue&type=template&id=7909027a&scoped=true"
import script from "./emailSendRecord.vue?vue&type=script&lang=js"
export * from "./emailSendRecord.vue?vue&type=script&lang=js"
import style0 from "./emailSendRecord.vue?vue&type=style&index=0&id=7909027a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7909027a",
  null
  
)

export default component.exports